module.exports = "/images/2_3650ed.png";